import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Header from './components/Header';
import PageOne from './components/PageOne';
import PageTwo from './components/PageTwo';
import PageThree from './components/PageThree';
import PageFour from './components/PageFour';
import PageFive from './components/PageFive';
import PageSix from './components/PageSix';
import PageResults from './components/PageResults';
import { Energy, LoseWeight, Immunity, Focus, Face, Eye, Smile, Gut, Fruit, Shoe, AntiAging } from './icons/Icons';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

const apiQuizRetail = 'https://app.get-nourished.com/api/klaviyo/quiz-retail--uk';

const RetailQuiz = () => {
  const [pageIndex, setPageIndex] = useState(1);
  const [kidsName, setKidsName] = useState('');
  const [gender, setGender] = useState('');
  const [pregnantAnswer, setPregnantAnswer] = useState('');
  const [age, setAge] = useState('');
  const [suitableAge, setSuitableAge] = useState(true);
  const [weightingAnswers, setWeightingsAnswers] = useState([]);
  const [activeGoalsAnswer, setActiveGoalsAnswer] = useState([]);
  const [specificDiet, setSpecificDiet] = useState('');
  const [dietAnswersIndex, setDietAnswersIndex] = useState([]);
  const [hungryBetweenMeals, setHungryBetweenMeals] = useState('');
  const [processedFoodAnswer, setProcessedFoodAnswer] = useState('');
  const [fruitVegAnswer, setFruitVegAnswer] = useState('');
  const [glassesAnswer, setGlassesAnswer] = useState('');
  const [energySliderValue, setEnergySliderValue] = useState(50);
  const [activitySliderValue, setActivitySliderValue] = useState(50);
  const [sleepSliderValue, setSleepSliderValue] = useState(50);
  const [screenSliderValue, setScreenSliderValue] = useState(50);
  const [attentionSliderValue, setAttentionSliderValue] = useState(50);
  const [conditionsAnswerIndex, setConditionsAnswerIndex] = useState([]);
  const [email, setEmail] = useState('');
  const [consent, setConsent] = useState(false);
  const [retailStore, setRetailStore] = useState('Store not set');
  const [data, setData] = useState({
    blend: '',
    blendHighlights: [],
    blendImageUrl: '',
  });

  useEffect(() => {
    if (data.blend != '' && data.blendHighlights && data.blendHighlights.length > 0 && data.blendImageUrl != '') {
      setPageIndex(pageIndex + 1);
    }
  }, [data]);

  useEffect(() => {
    if (window.location.href.includes('brown-thomas')) {
      setRetailStore('Brown Thomas');
    } else if (window.location.href.includes('selfridges')) {
      setRetailStore('Selfridges');
    }
  }, [])

  const genderAnswers = [
    {
      "name": "gender",
      "label": "Male",
      "value": "male"
    },
    {
      "name": "gender",
      "label": "Female",
      "value": "female"
    },
    {
      "name": "gender",
      "label": "Prefer not to say",
      "value": "opt-out"
    }
  ];

  const logPregnantAnswer = (event) => {
    const radioValue = event.target.value;

    if (radioValue === 'yes') {
      setWeightingsAnswers(prevWeightings => ({
        ...prevWeightings,
        "pregnant": {
          "products": [
            {
              'the-prenatal-stack': 20000000
            },
          ]
        }
      }))
      setPregnantAnswer(radioValue);
    } else {
      setWeightingsAnswers(prevWeightings => ({
        ...prevWeightings,
        "pregnant": {}
      }));
      setPregnantAnswer(radioValue);
    }
  };

  const goalsQuestion = {
    "question": `What is the number one priority for your health right now?`,
    "answers": [
      {
        "label": 'More energy',
        "icon": 'energy',
        "questionId": 'goals',
        "products": [
          {
            'nourished-essentials': 50000
          },
        ]
      },
      {
        "label": 'Lose weight or tone up',
        "icon": 'loseWeight',
        "questionId": 'goals',
        "products": [
          {
            'pre-blend-high-impact-shape-up-nutrients': 200000
          },
        ]
      },
      {
        "label": 'Better immunity',
        "icon": 'immunity',
        "questionId": 'goals',
        "products": [
          {
            'pre-blend-the-inner-defence-stack': 50000
          },
        ]
      },
      {
        "label": 'Better focus & memory',
        "icon": 'focus',
        "questionId": 'goals',
        "products": [
          {
            'pre-blend-high-impact-gamer-nutrients': 10000
          },
          {
            'pre-blend-high-flyer': 25000
          }
        ]
      },
      {
        "label": 'Improve skin, hair, nails & acne',
        "icon": "face",
        "questionId": 'goals',
        "products": [
          {
            'pre-blend-inner-beauty': 20000
          },
        ]
      },
      {
        "label": 'Better stress management & mental wellbeing',
        "icon": "smile",
        "questionId": 'goals',
        "products": [
          {
            'pre-blend-inner-peace': 50000
          },
        ]
      },
      {
        "label": 'Improve Performance, Endurance & Recovery',
        "icon": "shoe",
        "questionId": 'goals',
        "products": [
          {
            'pre-blend-inner-strength': 50000
          },
        ]
      },
      {
        "label": 'Delay signs of aging',
        "icon": "antiAging",
        "questionId": 'goals',
        "products": [
          {
            'pre-blend-inner-beauty': 20000
          },
        ]
      },
    ]
  };

  const dietsQuestion = {
    "question": "Which diet?",
    "subText": "Either by choice or becuase of allergies",
    "answers": [
      {
        "label": 'Vegetarian',
        "questionId": 'diet',
        "products": [
          {
            "pre-blend-plant-based-power": 0
          },
        ]
      },
      {
        "label": "Vegan",
        "questionId": "diet",
        "products": [
          {
            "pre-blend-plant-based-power": 0
          },
        ]
      },
      {
        "label": "Pescatarian",
        "questionId": "diet",
      },
      {
        "label": "Dairy free",
        "questionId": "diet",
      },
      {
        "label": "Gluten free",
        "questionId": "diet",
      },
      {
        "label": "Nut free",
        "questionId": "diet",
      },
      {
        "label": "Reducetarian",
        "questionId": "diet",
      }
    ]
  };

  const conditionsQuestion = {
    "answers": [
      {
        "label": "Asthma",
        "questionId": "conditions",
        "products": [
          {
            'pre-blend-the-inner-defence-stack': 20000
          },
        ]
      },
      {
        "label": "Hayfever",
        "questionId": "conditions",
        "products": [
          {
            'pre-blend-the-inner-defence-stack': 20000
          },
        ]
      },
      {
        "label": "Frequent colds or flus",
        "questionId": "conditions",
        "products": [
          {
            'pre-blend-the-inner-defence-stack': 50000
          },
        ]
      },
      {
        "label": "High Blood pressure or hypertension",
        "questionId": "conditions",
        "products": [
          {
            'inner-vitality': 20000
          },
        ]
      },
      {
        "label": "Crohn's Disease or IBS",
        "questionId": "conditions",
        "products": [
          {
            'nourished-essentials': 10000
          },
        ]
      },
      {
        "label": "Headaches or migraines",
        "questionId": "conditions",
        "products": [
          {
            'pre-blend-plant-based-power': 0
          },
        ]
      },
      {
        "label": "Anxiety",
        "questionId": "conditions",
        "products": [
          {
            'pre-blend-inner-peace': 30000
          },
        ]
      },
      {
        "label": "Inflammation",
        "questionId": "conditions",
        "products": [
          {
            'nourished-essentials': 20000
          },
        ]
      },
      {
        "label": "Acne or Skin Complaints ",
        "questionId": "conditions",
        "products": [
          {
            'pre-blend-inner-beauty': 20000
          },
        ]
      },
      {
        "label": "Menopause or Pre Menopause",
        "questionId": "conditions",
        "products": [
          {
            'the-meno-pause-stack': 1000000
          },
        ]
      },
      {
        "label": "Stomach or Digestion Issues",
        "questionId": "conditions",
        "products": [
          {
            'nourished-essentials': 10000
          },
        ]
      },
      {
        "label": "None",
        "questionId": "conditions",
        "products": []
      },
    ]
  };

  const renderGenderAnswers = genderAnswers.map((answer) => {
    return (
      <button
        key={answer.value}
        className={`answer-button ${gender === answer.value ? 'answer-button--active' : ''}`}
        name={answer.name}
        onClick={() => setGender(answer.value)}
      >
        {answer.label}
      </button>
    );
  });

  const onChangeNumber = (e) => {
    const re = /^[0-9\b]+$/;
    // make sure that only numbers can be input into the age field
    if (e.target.value === '' || re.test(e.target.value)) {
      setAge(e.target.value);
    }
  };

  const checkAge = () => {
    if (age > 17) {
      setSuitableAge(true);
    } else {
      setSuitableAge(false);
    }
  };

  const ageWarningMessage = () => {
    if (!suitableAge && age < 17) {
      return (
        <p>You must be 18 or older</p>
      );
    } else {
      return;
    }
  };

  const renderGoalAnswers = goalsQuestion.answers.map((answer, index) => {
    return (
      <div
        key={index}
        className={`answer-button answer-button__icon ${activeGoalsAnswer === index ? 'answer-button--active' : ''}`}
        onClick={e => logAnswers(answer, index, answer.questionId)}
      >
        {answer.icon === 'energy' ? <Energy /> : ''}
        {answer.icon === 'loseWeight' ? <LoseWeight /> : ''}
        {answer.icon === 'immunity' ? <Immunity /> : ''}
        {answer.icon === 'focus' ? <Focus /> : ''}
        {answer.icon === 'face' ? <Face /> : ''}
        {answer.icon === 'eye' ? <Eye /> : ''}
        {answer.icon === 'smile' ? <Smile /> : ''}
        {answer.icon === 'gut' ? <Gut /> : ''}
        {answer.icon === 'fruit' ? <Fruit /> : ''}
        {answer.icon === 'shoe' ? <Shoe /> : ''}
        {answer.icon === 'antiAging' ? <AntiAging /> : ''}

        {answer.label}
      </div>
    );
  });

  const logAnswers = (answer, index, questionId) => {
    if (activeGoalsAnswer === index) {
      setActiveGoalsAnswer([]);
      setWeightingsAnswers(prevWeightings => ({
        ...prevWeightings,
        [questionId]: {}
      }));
    } else {
      setActiveGoalsAnswer(index);
      if (answer.products !== undefined) {
        setWeightingsAnswers(prevWeightings => ({
          ...prevWeightings,
          [questionId]: answer
        }));
      }
    }
  };

  const logMultipleAnswers = (answer, index, questionId) => {
    // If answer is already selected...
    if (dietAnswersIndex.indexOf(index) !== -1) {
      // remove it from the index tracker
      const newDietAnswersIndex = dietAnswersIndex.filter(item => item !== index);
      setDietAnswersIndex(newDietAnswersIndex);
      //remove the weighting
      let weightingsToKeep = [];
      weightingAnswers[questionId].forEach(element => {
        if (element.label !== index) {
          weightingsToKeep.push(element);
        }
      });
      setWeightingsAnswers(prevWeightings => ({
        ...prevWeightings,
        [questionId]: weightingsToKeep
      }));
    } else {
      setDietAnswersIndex(prevAnswers => ([
        ...prevAnswers,
        index
      ]));
      if (answer.products !== undefined) {
        if (weightingAnswers[questionId] && weightingAnswers[questionId].length > 0) {
          const updatedAnswer = [...weightingAnswers[questionId], answer];
          setWeightingsAnswers(prevWeightings => ({
            ...prevWeightings,
            [questionId]: updatedAnswer
          }));
        } else {
          setWeightingsAnswers(prevWeightings => ({
            ...prevWeightings,
            [questionId]: [answer]
          }));
        }
      }
    }
  };

  const logMultipleConditionsAnswers = (answer, index, questionId) => {
    // If answer is already selected...
    if (conditionsAnswerIndex.indexOf(index) !== -1) {
      // remove it from the index tracker
      const newConditionsAnswerIndex = conditionsAnswerIndex.filter(item => item !== index);
      setConditionsAnswerIndex(newConditionsAnswerIndex);
      //remove the weighting
      let weightingsToKeep = [];
      weightingAnswers[questionId].forEach(element => {
        if (element.label !== index) {
          weightingsToKeep.push(element);
        }
      });
      setWeightingsAnswers(prevWeightings => ({
        ...prevWeightings,
        [questionId]: weightingsToKeep
      }));
    } else {
      setConditionsAnswerIndex(prevAnswers => ([
        ...prevAnswers,
        index
      ]));
      if (answer.products !== undefined) {
        if (weightingAnswers[questionId] && weightingAnswers[questionId].length > 0) {
          const updatedAnswer = [...weightingAnswers[questionId], answer];
          setWeightingsAnswers(prevWeightings => ({
            ...prevWeightings,
            [questionId]: updatedAnswer
          }));
        } else {
          setWeightingsAnswers(prevWeightings => ({
            ...prevWeightings,
            [questionId]: [answer]
          }));
        }
      }
    }
  };

  const logHungryAnswer = (event) => {
    const radioValue = event.target.value;

    if (radioValue === 'yes') {
      setWeightingsAnswers(prevWeightings => ({
        ...prevWeightings,
        "hungry": {
          "products": [
            {
              "pre-blend-high-impact-gamer-nutrients": 10000
            },
          ]
        }
      }))
      setHungryBetweenMeals('yes');
    } else {
      setWeightingsAnswers(prevWeightings => ({
        ...prevWeightings,
        "hungry": {}
      }));
      setHungryBetweenMeals('no');
    }
  };

  const logGlassesAnswer = (event) => {
    const radioValue = event.target.value;

    if (radioValue === 'yes') {
      setWeightingsAnswers(prevWeightings => ({
        ...prevWeightings,
        "glasses": {}
      }))
      setGlassesAnswer(radioValue);
    } else {
      setWeightingsAnswers(prevWeightings => ({
        ...prevWeightings,
        "glasses": {}
      }));
      setGlassesAnswer(radioValue);
    }
  };

  const onSpecificDietClick = (event) => {
    if (event.target.value === 'no') {
      setDietAnswersIndex([]);
      setWeightingsAnswers(prevWeightings => ({
        ...prevWeightings,
        'diet': []
      }));
      setSpecificDiet('no');
    } else {
      setSpecificDiet('yes');
    }
  }

  const renderDietAnswers = dietsQuestion.answers.map((answer) => {
    return (
      <div
        key={answer.label}
        className={`answer-button ${dietAnswersIndex.indexOf(answer.label) !== -1 ? 'answer-button--active' : ''}`}
        onClick={e => logMultipleAnswers(answer, answer.label, answer.questionId)}
      >
        {answer.label}
      </div>
    );
  });

  const renderConditionsAnswers = conditionsQuestion.answers.map((answer) => {
    return (
      <div
        key={answer.label}
        className={`answer-button ${conditionsAnswerIndex.indexOf(answer.label) !== -1 ? 'answer-button--active' : ''}`}
        onClick={e => logMultipleConditionsAnswers(answer, answer.label, answer.questionId)}
      >
        {answer.label}
      </div>
    );
  });

  const handleFoodRadios = (e) => {
    switch (e.target.id) {
      case 'processedFoodRarely':
        setWeightingsAnswers(prevWeightings => ({
          ...prevWeightings,
          "processedFood": {}
        }));
        setProcessedFoodAnswer(e.target.id);
        break;
      case 'processedFood12':
        setWeightingsAnswers(prevWeightings => ({
          ...prevWeightings,
          "processedFood": {}
        }));
        setProcessedFoodAnswer(e.target.id);
        break;
      case 'processedFood34':
        setWeightingsAnswers(prevWeightings => ({
          ...prevWeightings,
          "processedFood": {}
        }));
        setProcessedFoodAnswer(e.target.id);
        break;
      case 'processedFood5':
        setWeightingsAnswers(prevWeightings => ({
          ...prevWeightings,
          "processedFood": {
            "products": [
              {
                'pre-blend-plant-based-power': 0
              },
            ]
          }
        }));
        setProcessedFoodAnswer(e.target.id);
        break;
      case 'fruitVegRarely':
        setWeightingsAnswers(prevWeightings => ({
          ...prevWeightings,
          "fruitVeg": {
            "products": [
              {
                'pre-blend-plant-based-power': 0
              },
            ]
          }
        }));
        setFruitVegAnswer(e.target.id);
        break;
      case 'fruitVeg12':
        setWeightingsAnswers(prevWeightings => ({
          ...prevWeightings,
          "fruitVeg": {
            "products": [
              {
                'pre-blend-plant-based-power': 0
              },
            ]
          }
        }));
        setFruitVegAnswer(e.target.id);
        break;
      case 'fruitVeg34':
        setWeightingsAnswers(prevWeightings => ({
          ...prevWeightings,
          "fruitVeg": {}
        }));
        setFruitVegAnswer(e.target.id);
        break;
      case 'fruitVeg5':
        setWeightingsAnswers(prevWeightings => ({
          ...prevWeightings,
          "fruitVeg": {}
        }));
        setFruitVegAnswer(e.target.id);
        break;
      default:
        break;
    }
  }

  const handleSlider = (value, sliderId) => {
    const sliderValue = value;

    switch (sliderId) {
      case 'energy':
        setEnergySliderValue(sliderValue);
        if (sliderValue < 34) {
          setWeightingsAnswers(prevWeightings => ({
            ...prevWeightings,
            "energySlider": {
              "products": [
                {
                  'nourished-essentials': 10000
                },
                {
                  'pre-blend-high-impact-shape-up-nutrients': 20000
                }
              ]
            }
          }));
        } else if (sliderValue < 67) {
          setWeightingsAnswers(prevWeightings => ({
            ...prevWeightings,
            "energySlider": {}
          }));
        } else {
          setWeightingsAnswers(prevWeightings => ({
            ...prevWeightings,
            "energySlider": {}
          }));
        }
        break;

      case 'activity':
        setActivitySliderValue(sliderValue);
        if (sliderValue < 34) {
          setWeightingsAnswers(prevWeightings => ({
            ...prevWeightings,
            "activitySlider": {}
          }));
        } else if (sliderValue < 67) {
          setWeightingsAnswers(prevWeightings => ({
            ...prevWeightings,
            "activitySlider": {}
          }));
        } else {
          setWeightingsAnswers(prevWeightings => ({
            ...prevWeightings,
            "activitySlider": {
              "products": [
                {
                  'pre-blend-high-impact-shape-up-nutrients': 10000
                },
              ]
            }
          }));
        }
        break;

      case 'sleep':
        setSleepSliderValue(sliderValue);
        if (sliderValue < 34) {
          setWeightingsAnswers(prevWeightings => ({
            ...prevWeightings,
            "sleepSlider": {
              "products": [
                {
                  'pre-blend-inner-peace': 15000
                },
              ]
            }
          }));
        } else if (sliderValue < 67) {
          setWeightingsAnswers(prevWeightings => ({
            ...prevWeightings,
            "sleepSlider": {}
          }));
        } else {
          setWeightingsAnswers(prevWeightings => ({
            ...prevWeightings,
            "sleepSlider": {}
          }));
        }
        break;

      case 'screen':
        setScreenSliderValue(sliderValue);
        if (sliderValue < 34) {
          setWeightingsAnswers(prevWeightings => ({
            ...prevWeightings,
            "screenSlider": {}
          }));
        } else if (sliderValue < 67) {
          setWeightingsAnswers(prevWeightings => ({
            ...prevWeightings,
            "screenSlider": {
              "products": [
                {
                  'pre-blend-high-impact-gamer-nutrients': 5000
                },
              ]
            }
          }));
        } else {
          setWeightingsAnswers(prevWeightings => ({
            ...prevWeightings,
            "screenSlider": {
              "products": [
                {
                  'pre-blend-high-impact-gamer-nutrients': 100000
                },
              ]
            }
          }));
        }
        break;

      case 'attention':
        setAttentionSliderValue(sliderValue);
        if (sliderValue < 34) {
          setWeightingsAnswers(prevWeightings => ({
            ...prevWeightings,
            "attentionSlider": {}
          }));
        } else if (sliderValue < 67) {
          setWeightingsAnswers(prevWeightings => ({
            ...prevWeightings,
            "attentionSlider": {
              "products": [
                {
                  'pre-blend-party-proofed': 10000
                },
              ]
            }
          }));
        } else {
          setWeightingsAnswers(prevWeightings => ({
            ...prevWeightings,
            "attentionSlider": {
              "products": [
                {
                  'pre-blend-party-proofed': 200000
                },
              ]
            }
          }));
        }
        break;
      default:
        break;
    }
  }

  const calculateWeights = async () => {
    let weights = {};

    const addToWeighting = (product, weighting) => {
      weights[product]
        ? weights[product] += weighting
        : weights[product] = weighting;
    }

    (function retrieveWeights(obj) {
      for (const [key, value] of Object.entries(obj)) {
        switch (key) {
          case 'pre-blend-inner-beauty':
            addToWeighting(key, value);
            break;
          case 'pre-blend-inner-peace':
            addToWeighting(key, value);
            break;
          case 'nourished-essentials':
            addToWeighting(key, value);
            break;

          case 'pre-blend-high-impact-gamer-nutrients':
            addToWeighting(key, value);
            break;

          case 'pre-blend-high-flyer':
            addToWeighting(key, value);
            break;

          case 'pre-blend-plant-based-power':
            addToWeighting(key, value);
            break;

          case 'pre-blend-party-proofed':
            addToWeighting(key, value);
            break;

          case 'pre-blend-inner-strength':
            addToWeighting(key, value);
            break;

          case 'pre-blend-the-inner-defence-stack':
            addToWeighting(key, value);
            break;

          case 'pre-blend-high-impact-shape-up-nutrients':
            addToWeighting(key, value);
            break;

          case 'the-meno-pause-stack':
            addToWeighting(key, value);
            break;

          case 'inner-vitality':
            addToWeighting(key, value);
            break;

          case 'the-prenatal-stack':
            addToWeighting(key, value);
            break;

          default:
            break;
        }

        if (typeof value === 'object') {
          retrieveWeights(value);
        }
      }
    }(weightingAnswers));

    function findPreblend(obj) {
      return Object.keys(obj).sort((a, b) => { return obj[b] - obj[a] }).slice(0, 1);
    }

    let suggestedPreblend = findPreblend(weights);

    if (age > 55 && pregnantAnswer !== 'yes') {
      suggestedPreblend = 'inner-vitality';
    }

    let selectedDiets = '';

    if (dietAnswersIndex.length > 0) {
      selectedDiets = dietAnswersIndex.join(', ');
    }

    let payload = {
      kidsName,
      priority: weightingAnswers.goals.label,
      age,
      gender,
      selectedDiets,
    }
    // console.log(JSON.stringify(payload));
    // console.log(payload);
    // alert(suggestedPreblend);

    if (email !== '' && consent) {
      await klaviyoData(suggestedPreblend);
    }

    let highlights = null;

    axios({
      url: '/api/2020-07/graphql.json',
      method: 'post',
      headers: {
        'X-Shopify-Storefront-Access-Token': 'a405dd74f8328bdcd981ff3210ccac7c',
        'Content-Type': 'application/json',
      },
      data: {
        query: `
        query {
            productByHandle(handle: "${suggestedPreblend}") {
              metafields(identifiers: [{namespace: "highlights", key: "highlight"}]) {
                type
                namespace
                key
                value
              }
            }
          }
        `,
      },
    })
      .then((response) => {
        highlights = (JSON.parse(response.data.data.productByHandle.metafields[0].value));
      })
      .catch((error) => {
        console.log(error);
      });

    axios({
      url: `https://get-nourished.com/products/${suggestedPreblend}.js`,
      method: 'get',
    })
      .then((response) => {
        console.log(response);
        setData({
          blend: response.data.title,
          blendImageUrl: response.data.media[2].preview_image.src,
          blendHighlights: highlights,
        });
      })
      .catch((error) => {
        console.log(error);
      });
    // window.localStorage.setItem('kids-quiz-results', JSON.stringify(payload));
    // window.location = '/pages/kids-results';
  }

  const validatePageOne = () => {
    let errorMessage = '';

    if (kidsName === '') {
      errorMessage += 'Please enter a value for your name';
    } else if (gender === '') {
      errorMessage += 'Please select a gender option';
    } else if (age === '') {
      errorMessage += 'Please enter your age';
    } else if (!suitableAge) {
      errorMessage += 'Please check the age you entered';
    }

    if (errorMessage) {
      alert(errorMessage);
    } else {
      return true;
    }
  }

  const validatePageTwo = () => {
    if (activeGoalsAnswer.length < 1) {
      alert('Please select a goal');
    } else {
      return true;
    }
  }

  const validatePageThree = () => {
    let errorMessage = '';

    if (!specificDiet) {
      errorMessage += `Let us know if ${kidsName} follow a specific diet`;
    } else if (!hungryBetweenMeals) {
      errorMessage += `Let us know if ${kidsName} gets hungry between meals`;
    } else if (!processedFoodAnswer) {
      errorMessage += `Please tell us how often ${kidsName} eats processed food a week`;
    } else if (!fruitVegAnswer) {
      errorMessage += `Please tell us how often ${kidsName} eats fruit & veg a week`;
    }

    if (errorMessage) {
      alert(errorMessage);
    } else {
      return true;
    }
  }

  const validatePageFive = () => {
    if (!glassesAnswer) {
      alert(`Please tell us if ${kidsName} wears glasses or contact lenses`);
    } else {
      return true;
    }
  }

  const klaviyoData = (resultsPreblend) => {
    return new Promise((resolve, reject) => {
      let selectedDiets = 'non selected';
      let healthConditions = 'non selected';

      if (dietAnswersIndex.length > 0) {
        selectedDiets = dietAnswersIndex.join(', ');
      }

      if (conditionsAnswerIndex.length > 0) {
        healthConditions = conditionsAnswerIndex.join(', ');
      }

      const responses = {
        "responses": [
          {
            "question": "Retail: Name",
            "answers": `${kidsName}`
          },
          {
            "question": "Retail: gender",
            "answers": `${gender}`
          },
          {
            "question": "Retail: Pregnant",
            "answers": `${pregnantAnswer}`
          },
          {
            "question": "Retail: Age",
            "answers": `${age}`
          },
          {
            "question": "Retail: Goal",
            "answers": `${weightingAnswers.goals.label}`
          },
          {
            "question": "Retail: Specific diet?",
            "answers": `${specificDiet}`
          },
          {
            "question": "Retail: Selected diets",
            "answers": `${selectedDiets}`
          },
          {
            "question": "Retail: Hungry between meals?",
            "answers": `${hungryBetweenMeals}`
          },
          {
            "question": "Retail: Processes food frequency:",
            "answers": `${processedFoodAnswer}`
          },
          {
            "question": "Retail: Fruit & Veg frequency:",
            "answers": `${fruitVegAnswer}`
          },
          {
            "question": "Retail: Energy slider value:",
            "answers": `${energySliderValue}`
          },
          {
            "question": "Retail: Activity slider value:",
            "answers": `${activitySliderValue}`
          },
          {
            "question": "Retail: Sleep slider value:",
            "answers": `${sleepSliderValue}`
          },
          {
            "question": "Retail: Screen slider value:",
            "answers": `${screenSliderValue}`
          },
          {
            "question": "Retail: Alcohol slider value:",
            "answers": `${attentionSliderValue}`
          },
          {
            "question": "Retail: Health conditions:",
            "answers": `${healthConditions}`
          },
          {
            "question": "Retail: Wear glasses or contacts?",
            "answers": `${glassesAnswer}`
          },
          {
            "question": "Retail: Results",
            "answers": `${resultsPreblend}`
          },
          {
            "question": "Retail: Origin",
            "answers": `${retailStore}`
          }
        ]
      };

      const cusomerData = { email: email }

      let submittedPayload = [];
      submittedPayload.push(cusomerData, responses);

      // console.log(submittedPayload);

      if (email !== '') {
        fetch(apiQuizRetail, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(submittedPayload),
        })
          .then(function (res) {
            resolve(res);
          })
          .catch(function (error) {
            reject(error);
          });
      }
    });
  }

  const nextPage = (continueIndex) => {
    let quizRoot = document.getElementById('root');
    quizRoot.scrollIntoView();

    switch (continueIndex) {
      case '1':
        if (validatePageOne() === true) {
          setPageIndex(pageIndex + 1);
        }
        break;
      case '2':
        if (validatePageTwo() === true) {
          setPageIndex(pageIndex + 1);
        }
        break;
      case '3':
        if (validatePageThree() === true) {
          setPageIndex(pageIndex + 1);
        }
        break;
      case '4':
        setPageIndex(pageIndex + 1);
        break;
      case '5':
        if (validatePageFive() === true) {
          setPageIndex(pageIndex + 1);
        }
        break;
      case '6':
        calculateWeights(weightingAnswers);
        break;
      default:
        break;
    }

  }

  const backPage = () => {
    let quizRoot = document.getElementById('root');
    quizRoot.scrollIntoView();
    if (pageIndex > 1) {
      setPageIndex(pageIndex - 1);
    }
  }

  return (
    <div className="kids-quiz">
      <Header pageIndex={pageIndex} backPage={backPage} />

      <TransitionGroup>
        <CSSTransition
          key={pageIndex}
          in={true}
          appear={true}
          timeout={1000}
          classNames="slide"
        >
          <>
            {{
              1: (
                <PageOne
                  kidsName={kidsName}
                  setKidsName={setKidsName}
                  renderGenderAnswers={renderGenderAnswers}
                  gender={gender}
                  logPregnantAnswer={logPregnantAnswer}
                  pregnantAnswer={pregnantAnswer}
                  onChangeNumber={onChangeNumber}
                  checkAge={checkAge}
                  age={age}
                  ageWarningMessage={ageWarningMessage}
                  nextPage={nextPage}
                  suitableAge={suitableAge}
                />
              ),
              2: (
                <PageTwo
                  goalsQuestion={goalsQuestion}
                  renderGoalAnswers={renderGoalAnswers}
                  activeGoalsAnswer={activeGoalsAnswer}
                  nextPage={nextPage}
                />
              ),
              3: (
                <PageThree
                  kidsName={kidsName}
                  gender={gender}
                  onSpecificDietClick={onSpecificDietClick}
                  specificDiet={specificDiet}
                  renderDietAnswers={renderDietAnswers}
                  dietAnswersIndex={dietAnswersIndex}
                  logHungryAnswer={logHungryAnswer}
                  hungryBetweenMeals={hungryBetweenMeals}
                  handleFoodRadios={handleFoodRadios}
                  processedFoodAnswer={processedFoodAnswer}
                  fruitVegAnswer={fruitVegAnswer}
                  nextPage={nextPage}
                />
              ),
              4: (
                <PageFour
                  kidsName={kidsName}
                  energySliderValue={energySliderValue}
                  handleSlider={handleSlider}
                  activitySliderValue={activitySliderValue}
                  sleepSliderValue={sleepSliderValue}
                  screenSliderValue={screenSliderValue}
                  attentionSliderValue={attentionSliderValue}
                  nextPage={nextPage}
                />
              ),
              5: (
                <PageFive
                  kidsName={kidsName}
                  renderConditionsAnswers={renderConditionsAnswers}
                  gender={gender}
                  logGlassesAnswer={logGlassesAnswer}
                  glassesAnswer={glassesAnswer}
                  nextPage={nextPage}
                />
              ),
              6: (
                <PageSix
                  setEmail={setEmail}
                  email={email}
                  consent={consent}
                  setConsent={setConsent}
                  nextPage={nextPage}
                />
              ),
              7: (
                <PageResults
                  kidsName={kidsName}
                  data={data}
                  retailStore={retailStore}
                />
              )
            }[pageIndex]}
          </>
        </CSSTransition>
      </TransitionGroup>

    </div>
  );
};

export default RetailQuiz;